import cn from 'classnames';
import type React from 'react';
import { memo } from 'react';
import * as st from './styles.module.scss';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isActive?: boolean;
  children?: React.ReactNode;
  variant?: 'subnav' | 'standart';
  className?: string;
}

export const NavTab: React.FC<Props> = memo(
  ({ children, isActive, variant = 'standart', className, onClick, ...props }) => {
    return (
      <button
        className={cn(st[variant], isActive && st.active, className)}
        onClick={onClick}
        {...props}
      >
        {children}
      </button>
    );
  }
);
